/**
 * Permission Utilities
 * Handles permission structure with value and label properties
 */

// Permission structure with value and label
export const PERMISSION_STRUCTURE = {
  "inventory": {
    "inventory_read": {"value": "inventory_read", "label": "Inventory Read"},
    "inventory_add": {"value": "inventory_add", "label": "Inventory Add"},
    "inventory_evaluate_read": {"value": "inventory_evaluate_read", "label": "Inventory Evaluate Read"},
    "inventory_search_read": {"value": "inventory_search_read", "label": "Inventory Search Read"},
    "inventory_queues_read": {"value": "inventory_queues_read", "label": "Inventory Queues Read"},
    "inventory_status_read": {"value": "inventory_status_read", "label": "Inventory Status Read"},
    "inventory_images_add": {"value": "inventory_images_add", "label": "Inventory Images Add"},
    "inventory_files_add": {"value": "inventory_files_add", "label": "Inventory Files Add"},
    "inventory_expenses_add": {"value": "inventory_expenses_add", "label": "Inventory Expenses Add"},
    "inventory_status_add": {"value": "inventory_status_add", "label": "Inventory Status Add"},
    "inventory_buyers_read": {"value": "inventory_buyers_read", "label": "Inventory Buyers Read"},
    "inventory_buyers_add": {"value": "inventory_buyers_add", "label": "Inventory Buyers Add"},
    "inventory_notes_add": {"value": "inventory_notes_add", "label": "Inventory Notes Add"},
    "inventory_flags_add": {"value": "inventory_flags_add", "label": "Inventory Flags Add"},
    "inventory_ecabinet_add": {"value": "inventory_ecabinet_add", "label": "Inventory ECabinet Add"},
    "inventory_delete": {"value": "inventory_delete", "label": "Inventory Delete"},
    "inventory_edit": {"value": "inventory_edit", "label": "Inventory Edit"}
  },
  "customers": {
    "customers_read": {"value": "customers_read", "label": "Customers Read"},
    "customers_search_read": {"value": "customers_search_read", "label": "Customers Search Read"},
    "customers_list_read": {"value": "customers_list_read", "label": "Customers List Read"},
    "customers_add": {"value": "customers_add", "label": "Customers Add"},
    "customers_edit": {"value": "customers_edit", "label": "Customers Edit"},
    "customers_delete": {"value": "customers_delete", "label": "Customers Delete"}
  },
  "deals": {
    "deals_read": {"value": "deals_read", "label": "Deals Read"},
    "deals_figure_read": {"value": "deals_figure_read", "label": "Deals Figure Read"},
    "deals_add": {"value": "deals_add", "label": "Deals Add"},
    "deals_queues_read": {"value": "deals_queues_read", "label": "Deals Queues Read"},
    "deals_edit": {"value": "deals_edit", "label": "Deals Edit"},
    "deals_delete": {"value": "deals_delete", "label": "Deals Delete"}
  },
  "reports": {
    "reports_read": {"value": "reports_read", "label": "Reports Read"},
    "reports_daily_recap": {"value": "reports_daily_recap", "label": "Daily Recap Reports"},
    "reports_standard_tax": {"value": "reports_standard_tax", "label": "Standard Tax Reports"},
    "reports_ecabinet": {"value": "reports_ecabinet", "label": "ECabinet Reports"}
  },
  "logs": {
    "logs_read": {"value": "logs_read", "label": "Logs Read"}
  },
  "settings": {
    "settings_read": {"value": "settings_read", "label": "Settings Read"},
    "settings_institution_read": {"value": "settings_institution_read", "label": "Institution Settings Read"},
    "settings_roles_read": {"value": "settings_roles_read", "label": "Roles Settings Read"},
    "settings_channels_read": {"value": "settings_channels_read", "label": "Channels Settings Read"},
    "settings_portfolios_read": {"value": "settings_portfolios_read", "label": "Portfolios Settings Read"},
    "settings_queue_manager_read": {"value": "settings_queue_manager_read", "label": "Queue Manager Settings Read"},
    "settings_queue_layouts_read": {"value": "settings_queue_layouts_read", "label": "Queue Layouts Settings Read"},
    "settings_flags_read": {"value": "settings_flags_read", "label": "Flags Settings Read"},
    "settings_locations_read": {"value": "settings_locations_read", "label": "Locations Settings Read"},
    "settings_user_defined_read": {"value": "settings_user_defined_read", "label": "User Defined Settings Read"},
    "settings_equipments_read": {"value": "settings_equipments_read", "label": "Equipments Settings Read"},
    "settings_inventory_parameters_read": {"value": "settings_inventory_parameters_read", "label": "Inventory Parameters Settings Read"},
    "settings_email_read": {"value": "settings_email_read", "label": "Email Settings Read"},
    "settings_payment_read": {"value": "settings_payment_read", "label": "Payment Settings Read"}
  },
  "user_defined": {
    "user_defined_accounts_read": {"value": "user_defined_accounts_read", "label": "User Defined Accounts Read"},
    "user_defined_accounts_add": {"value": "user_defined_accounts_add", "label": "User Defined Accounts Add"},
    "user_defined_deals_read": {"value": "user_defined_deals_read", "label": "User Defined Deals Read"},
    "user_defined_deals_add": {"value": "user_defined_deals_add", "label": "User Defined Deals Add"},
    "user_defined_inventory_read": {"value": "user_defined_inventory_read", "label": "User Defined Inventory Read"},
    "user_defined_inventory_add": {"value": "user_defined_inventory_add", "label": "User Defined Inventory Add"}
  },
  "users": {
    "users_read": {"value": "users_read", "label": "Users Read"},
    "users_add": {"value": "users_add", "label": "Users Add"},
    "users_edit": {"value": "users_edit", "label": "Users Edit"},
    "users_delete": {"value": "users_delete", "label": "Users Delete"}
  },
  "locations": {
    "locations_add": {"value": "locations_add", "label": "Locations Add"},
    "locations_read": {"value": "locations_read", "label": "Locations Read"},
    "locations_edit": {"value": "locations_edit", "label": "Locations Edit"},
    "locations_delete": {"value": "locations_delete", "label": "Locations Delete"}
  },
  "flags": {
    "flags_add": {"value": "flags_add", "label": "Flags Add"},
    "flags_read": {"value": "flags_read", "label": "Flags Read"},
    "flags_edit": {"value": "flags_edit", "label": "Flags Edit"},
    "flags_delete": {"value": "flags_delete", "label": "Flags Delete"}
  },
  "channels": {
    "channels_add": {"value": "channels_add", "label": "Channels Add"},
    "settings_channels_read": {"value": "settings_channels_read", "label": "Channels Read"},
    "channels_edit": {"value": "channels_edit", "label": "Channels Edit"},
    "channels_delete": {"value": "channels_delete", "label": "Channels Delete"}
  },
  "roles": {
    "roles_add": {"value": "roles_add", "label": "Roles Add"},
    "roles_read": {"value": "roles_read", "label": "Roles Read"},
    "roles_edit": {"value": "roles_edit", "label": "Roles Edit"},
    "roles_delete": {"value": "roles_delete", "label": "Roles Delete"}
  },
  "equipments": {
    "equipments_add": {"value": "equipments_add", "label": "Equipments Add"},
    "equipments_read": {"value": "equipments_read", "label": "Equipments Read"},
    "equipments_edit": {"value": "equipments_edit", "label": "Equipments Edit"},
    "equipments_delete": {"value": "equipments_delete", "label": "Equipments Delete"}
  },
  "admin": {
    "superadmin_tenant_read": {"value": "superadmin_tenant_read", "label": "Super Admin Tenant Read"},
    "superadmin_tenant_add": {"value": "superadmin_tenant_add", "label": "Super Admin Tenant Add"},
    "superadmin_tenant_edit": {"value": "superadmin_tenant_edit", "label": "Super Admin Tenant Edit"},
    "superadmin_tenant_delete": {"value": "superadmin_tenant_delete", "label": "Super Admin Tenant Delete"}
  }
};

/**
 * Get permission label by key
 * @param {string} permissionKey - The permission key
 * @returns {string} The permission label or the key itself if not found
 */
export const getPermissionLabel = (permissionKey) => {
  for (const category in PERMISSION_STRUCTURE) {
    if (PERMISSION_STRUCTURE[category][permissionKey]) {
      return PERMISSION_STRUCTURE[category][permissionKey].label;
    }
  }
  return permissionKey; // Fallback to key if not found
};

/**
 * Get permission value by key
 * @param {string} permissionKey - The permission key
 * @returns {string} The permission value or the key itself if not found
 */
export const getPermissionValue = (permissionKey) => {
  for (const category in PERMISSION_STRUCTURE) {
    if (PERMISSION_STRUCTURE[category][permissionKey]) {
      return PERMISSION_STRUCTURE[category][permissionKey].value;
    }
  }
  return permissionKey; // Fallback to key if not found
};

/**
 * Get all permissions as flat array
 * @returns {Array} Array of permission objects with value and label
 */
export const getAllPermissions = () => {
  const permissions = [];
  for (const category in PERMISSION_STRUCTURE) {
    for (const key in PERMISSION_STRUCTURE[category]) {
      permissions.push({
        key,
        ...PERMISSION_STRUCTURE[category][key]
      });
    }
  }
  return permissions;
};

/**
 * Get permissions by category
 * @param {string} category - The category name
 * @returns {Object} Object containing permissions for the specified category
 */
export const getPermissionsByCategory = (category) => {
  return PERMISSION_STRUCTURE[category] || {};
};

/**
 * Get all categories
 * @returns {Array} Array of category names
 */
export const getPermissionCategories = () => {
  return Object.keys(PERMISSION_STRUCTURE);
};

/**
 * Check if user has permission
 * @param {Object} userPermissions - User's permissions object
 * @param {string} permissionKey - The permission key to check
 * @returns {boolean} True if user has permission
 */
export const hasPermission = (userPermissions, permissionKey) => {
  return userPermissions && userPermissions[permissionKey] === true;
};

/**
 * Tenant-level Website feature (`api::tenant.tenant` web_enabled).
 * True only when explicitly enabled on the account or selected tenant.
 */
export const isTenantWebEnabled = (account) => {
  if (!account) return false;
  if (account.web_enabled === true) return true;
  if (account.web?.web_enabled === true) return true;
  if (Array.isArray(account.tenants) && account.selected_tenant != null) {
    const selectedId = String(account.selected_tenant);
    const tenant = account.tenants.find((tn) => String(tn?.id) === selectedId);
    if (tenant?.web_enabled === true) return true;
    if (tenant?.web?.web_enabled === true) return true;
  }
  return false;
};

/**
 * Website / web_maker nav+routes: tenant web_enabled overrides web_maker permission.
 * Super admin is exempt (manages sites across tenants).
 */
export const isWebMakerRouteBlocked = (account, route) => {
  if (!account || account.is_super_admin) return false;
  const isWebMakerRoute =
    route?.permission === "web_maker" ||
    route?.state === "webMakerCollapse" ||
    route?.requiresWebEnabled === true;
  if (!isWebMakerRoute) return false;
  return !isTenantWebEnabled(account);
};

/**
 * Convert simple permissions object to structured format
 * @param {Object} simplePermissions - Simple permissions object with boolean values
 * @returns {Object} Structured permissions object with value and label
 */
export const convertToStructuredPermissions = (simplePermissions) => {
  const structured = {};
  
  for (const category in PERMISSION_STRUCTURE) {
    structured[category] = {};
    for (const key in PERMISSION_STRUCTURE[category]) {
      const hasPermission = simplePermissions && simplePermissions[key] === true;
      structured[category][key] = {
        ...PERMISSION_STRUCTURE[category][key],
        enabled: hasPermission
      };
    }
  }
  
  return structured;
};

/**
 * Convert structured permissions back to simple format
 * @param {Object} structuredPermissions - Structured permissions object
 * @returns {Object} Simple permissions object with boolean values
 */
export const convertToSimplePermissions = (structuredPermissions) => {
  const simple = {};
  
  for (const category in structuredPermissions) {
    for (const key in structuredPermissions[category]) {
      const permission = structuredPermissions[category][key];
      if (permission && typeof permission.enabled === 'boolean') {
        simple[key] = permission.enabled;
      }
    }
  }
  
  return simple;
}; 